export default function PHP_xml_set_default_handler() {
  return (
    <div>
      <h1>PHP_xml_set_default_handler</h1>
    </div>
  );
}
